import { render } from "./SouLojista.vue?vue&type=template&id=6c49deb4&scoped=true"
import script from "./SouLojista.vue?vue&type=script&lang=js"
export * from "./SouLojista.vue?vue&type=script&lang=js"

import "./SouLojista.vue?vue&type=style&index=0&id=6c49deb4&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c49deb4"]])

export default __exports__